import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../../commonComponents/translate';
import AmPieChart from '../../../../../commonComponents/charts/AmPieChart';

function VADistribution({ t, data }) {
  if (!data || data.length === 0) return null;

  const chartData = data.map(item => {
    let label;
    if (item.min === null) {
      label = `< ${item.max} VA`;
    } else if (item.max === null) {
      label = `> ${item.min} VA`;
    } else {
      label = `${item.min} - ${item.max} VA`;
    }
    return { label, value: item.total };
  });

  return (
    <div className="pureliink-chart-card">
      <h4 className="career-section-title">
        {t('pureliink.career.overview.vaDistribution')}
      </h4>
      <AmPieChart
        chartId="pureliink-va-distribution"
        containerClass="m-chart-container"
        stats={chartData}
        options={{ category: 'label', value: 'value' }}
      />
    </div>
  );
}

VADistribution.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      min: PropTypes.number,
      max: PropTypes.number,
      total: PropTypes.number,
    }),
  ).isRequired,
};

export default translate(VADistribution);
